import { useSurveyStore } from "@src/store/survey";

export const getHighlightOnHoverFunction = (layerId) => {
  return {
    action: "mousemove",
    layer: layerId,
    handler: (e, map) => {
      map.getCanvas().style.cursor = "pointer";
      const newHoverFeature = e.features[0];
      const hoverFeature = useSurveyStore.getState().hoverFeature;

      const shouldRemoveHover =
        hoverFeature?.id + 1 &&
        hoverFeature?.source &&
        (hoverFeature.id !== newHoverFeature.id ||
          hoverFeature.source !== newHoverFeature.source);

      if (shouldRemoveHover) {
        map.setFeatureState(
          {
            source: hoverFeature.source,
            id: hoverFeature.id,
          },
          { hover: false },
        );
      }

      const setHoverFeature = useSurveyStore.getState().setHoverFeature;
      setHoverFeature(newHoverFeature);
    },
  };
};

export const getUnhighlightOnHoverFunction = (layerId) => {
  return {
    action: "mouseleave",
    layer: layerId,
    handler: (e, map) => {
      const commentQuestion = useSurveyStore.getState().commentQuestion;
      if (!commentQuestion) {
        map.getCanvas().style.cursor = "";
      }
      const hoverFeature = useSurveyStore.getState().hoverFeature;
      if (hoverFeature?.id + 1) {
        map.setFeatureState(
          {
            source: hoverFeature.source,
            id: hoverFeature.id,
          },
          { hover: false },
        );
      }
      const setHoverFeature = useSurveyStore.getState().setHoverFeature;
      setHoverFeature(null);
    },
  };
};

export const mapEvents = [];
